var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBitmart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13556_12569)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_13556_12569)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.2527 25.6319C34.2647 24.3517 34.8141 22.7669 34.8114 21.1351C34.8114 17.1209 31.5591 14 27.5465 14H18.7246V14.9079H27.3509C30.8971 14.9079 33.772 17.6538 33.772 21.2C33.7742 22.5786 33.3308 23.921 32.508 25.0272L33.2527 25.6319Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2688 24.8802C33.2342 23.8987 33.7745 22.5767 33.7729 21.1999C33.7729 19.8065 33.2194 18.4702 32.2342 17.4848C31.249 16.4995 29.9127 15.9458 28.5193 15.9456H21.0597V16.8543H28.7132C29.2756 16.854 29.8325 16.9644 30.3522 17.1794C30.8718 17.3944 31.344 17.7097 31.7418 18.1072C32.1396 18.5047 32.4551 18.9767 32.6704 19.4963C32.8857 20.0158 32.9965 20.5727 32.9965 21.135C32.9972 21.7594 32.861 22.3764 32.5974 22.9425C32.3339 23.5086 31.9494 24.0099 31.4711 24.4113L32.2688 24.8802Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8297 24.1952C32.057 23.6589 32.9965 22.4905 32.9965 21.135C32.9965 19.2722 31.2268 17.7622 29.364 17.7622H22.8755V18.2806H29.2974C30.8348 18.2806 32.3457 19.5302 32.3457 21.0701C32.3457 22.3179 31.3566 23.3762 30.1618 23.7306L30.8297 24.1952Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1299 37.092H17.5571V37.9999H16.1299V37.092Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.557 35.2754H23.2649V35.9236H17.557V35.2754Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.557 31.2544H23.6544V31.7737H17.557V31.2544Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8219 31.2544H28.714V31.7737H24.8219V31.2544Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7246 29.4377H20.8001V29.957H18.7246V29.4377Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9675 29.4377H28.7132V29.957H21.9675V29.4377Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.1729 21.2649H28.5834V21.7842H24.1729V21.2649Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9843 17.7622H21.4492V18.2815H18.9843V17.7622Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6324 19.708H28.7132V20.2273H19.6324V19.708Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2974 21.2649H22.8754V21.7842H17.2974V21.2649Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8544 36.9623V37.8702H28.7132C32.7274 37.8702 35.9781 34.7477 35.9781 30.7351C35.9781 28.8084 35.2127 26.9605 33.8502 25.5981C32.4878 24.2356 30.6399 23.4702 28.7132 23.4702H22.357V24.2491H28.5193C30.2223 24.2494 31.8556 24.9261 33.0597 26.1304C34.2639 27.3347 34.9403 28.968 34.9403 30.6711C34.9403 34.2181 32.0655 36.9632 28.5193 36.9632L18.8544 36.9623Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.4105 25.4158V26.3245H29.8807C30.4429 26.3244 30.9997 26.4351 31.5191 26.6501C32.0386 26.8652 32.5106 27.1805 32.9082 27.578C33.3058 27.9755 33.6212 28.4475 33.8363 28.9669C34.0515 29.4863 34.1623 30.043 34.1623 30.6052C34.1623 31.7408 33.7112 32.8298 32.9082 33.6328C32.1053 34.4357 31.0162 34.8868 29.8807 34.8868H24.3026V35.9245H29.6834C30.3734 35.9245 31.0566 35.7886 31.694 35.5245C32.3315 35.2605 32.9107 34.8734 33.3985 34.3855C33.8864 33.8976 34.2733 33.3183 34.5373 32.6808C34.8012 32.0434 34.937 31.3601 34.9369 30.6701C34.9369 29.2767 34.3835 27.9404 33.3983 26.955C32.4131 25.9697 31.0768 25.416 29.6834 25.4158H20.4105Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1351 27.3623V27.8807H30.4649C32.0023 27.8807 33.5132 29.1303 33.5132 30.6702C33.5132 32.2076 32.0057 33.4597 30.4649 33.4597H16V34.1079H30.5298C32.3926 34.1079 34.1623 32.5979 34.1623 30.7351C34.1623 28.8723 32.3926 27.3623 30.5298 27.3623H23.1351Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13556_12569"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 26,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_13556_12569"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9781,
    height: 24,
    fill: "white",
    transform: "translate(16 14)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitmart);
export default __webpack_public_path__ + "static/media/Bitmart.2dd0adae511e3473a11825bbe947c1c3.svg";
export { ForwardRef as ReactComponent };